import React from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../components/Footer";
import Nav from "../components/Nav";
import { useSEO } from "../hooks/useSEO";

const Terms = () => {
  const navigate = useNavigate();
  useSEO(
    "Terms of Service | Mortgage Survival Playbook 2026",
    "Terms governing the $4,995 per-portfolio institutional license for the Mortgage Survival Playbook 2026: license grant, one-download delivery, permitted use, and refunds."
  );
  return (
    <>
      <Nav />
      <div className="legal-wrap">
        <h1>Terms of Service</h1>
        <div className="updated">Last updated: 2026 · ENVOLVP LLC</div>
        <p>These Terms govern your purchase and use of the Mortgage Survival Playbook 2026 (the "Product") from ENVOLVP LLC.</p>
        <h2>License Grant</h2>
        <p>Upon completed payment of the $4,995 flat fee, you receive a per-portfolio institutional license to use the Product within your organization. The license covers a single loan portfolio. Multi-portfolio and enterprise licensing is available on request.</p>
        <h2>Download &amp; Delivery</h2>
        <ul>
          <li>Each completed payment grants exactly <strong>one download</strong> of the deployment package via a secure, single-use link.</li>
          <li>The link expires after one successful download. Please back up your files immediately.</li>
          <li>If your download fails or you need a replacement, contact us with your Stripe order ID.</li>
        </ul>
        <h2>Permitted Use</h2>
        <p>The Product is licensed for internal operational use by the purchasing institution. Redistribution, resale, or public posting of the materials is prohibited.</p>
        <h2>Refunds</h2>
        <p>Because the Product is a digital deliverable granted on download, all sales are final once the package is downloaded. For pre-purchase evaluation, request the free sample package.</p>
        <h2>Disclaimer</h2>
        <p>The Product is an operational framework based on publicly available data (ATTOM, MBA, CFPB Regulation X). It does not constitute legal, financial, or regulatory advice. Your institution is responsible for its own compliance decisions.</p>
        <h2>Contact</h2>
        <p>ENVOLVP LLC, Houston, Texas · <a href="mailto:hello@mortgagesurvivalplaybook.com">hello@mortgagesurvivalplaybook.com</a></p>
        <a className="ty-back" onClick={() => navigate("/")} style={{ cursor: "pointer" }}>← Back to home</a>
      </div>
      <Footer />
    </>
  );
};

export default Terms;
